document.addEventListener('DOMContentLoaded', function() {
    var accordionHeaders = document.querySelectorAll('.__MyfAcc__header');

    accordionHeaders.forEach(function(header) {

        header.addEventListener('click', function() {
            var content = this.nextElementSibling;

            // Fermer tous les autres contenus d'accordéon et en-têtes
            document.querySelectorAll('.__MyfAcc__content').forEach(function(otherContent) {
            if (otherContent !== content) {
                otherContent.classList.remove('__MyfAcc__content--show');
            }
            });

            document.querySelectorAll('.__MyfAcc__header').forEach(function(otherHeader) {
            if (otherHeader !== header) {
                otherHeader.classList.remove('__MyfAcc__header--active');
            }
            });

            // Afficher/masquer le contenu et l'en-tête de l'accordéon actuel
            setTimeout(function() {
                content.classList.toggle('__MyfAcc__content--show');
                header.classList.toggle('__MyfAcc__header--active');
            }, 400);
        });

    });
});